<template>
    <section>
        <b-overlay :show="loading" no-wrap opacity="1">
        </b-overlay>
        <section class="configHeader">
            <div>
                <b-button class="addIndBtn" @click="openConfigsModal('addMainIndModal')">Adicionar Indicador
                    Gerencial</b-button>
                <b-input type="text" v-model="filterListText" placeholder="Pesquisar..."/>
            </div>

            <div>
                <b-button class="respBtn" @click="openConfigsModal('addRespModal')">
                    <b-icon-people-fill />
                    <span>Configurar Responsáveis</span>
                </b-button>
                <b-button class="generalConfigBtn" @click="openConfigsModal('generalConfigsModal')">
                    <b-icon-sliders />
                    <span>Configurações Gerais</span>
                </b-button>
            </div>
        </section>
        <div class="listIndContainer">
            <ManagementIndicators v-for="(ind, idx) in this.filterIndicators()" :key="'indMain-' + idx"
                :indicators="ind" :openDetailsFunc="openIndDetails" :removeIndicatorsFunc="askToRemoveInd"
                :mainIdx="idx" innerBtnLabel="Ver Detalhes" :showRemoveBtn="true" :showIndVal="false">
                <template #button>
                    <section class="indBtnGroup">
                        <b-button class="vincIndBtn"
                            @click="openConfigsModal('addOperationalIndModal', ind.MainIndicatorId)">
                            <b-icon-plus-circle-fill />
                            <span>Vincular Indicadores</span>
                        </b-button>
                        <b-button class="configTriggerBtn" @click="configTriggers(ind, ind.OperationalInds)">
                            <b-icon-gear-fill />
                            <span>Configurar Gatilhos</span>
                        </b-button>
                        <b-button class="deleteIndBtn" @click="askToRemoveInd(ind)">
                            <b-icon-trash-fill />
                        </b-button>
                    </section>
                </template>
            </ManagementIndicators>
        </div>

        <p v-if="this.indicators.length == 0" class="notFOundInd">Nenhum indicador encontrado.</p>

        <b-modal id="opIndDetailsRtaModal" title="Detalhes do Indicador" hide-footer size="md">
            <p><strong>Nome: </strong> {{ opIndDetails.IndicatorName }}</p>
            <p><strong>Tipo: </strong> {{ opIndDetails.CalcType }}</p>
            <p><strong>Gatilhos Configurados: </strong> {{ opIndDetails.Triggers }}</p>
            <p><strong>FCAs: </strong> {{ opIndDetails.FCACount }}</p>
            <p><strong>Último Valor Real: </strong> {{ opIndDetails.RealValue }}</p>
            <p><strong>Último Valor Previsto: </strong> {{ opIndDetails.PrevValue }}</p>
            <p><strong>Horário do Monitoramento: </strong> {{ opIndDetails.MonitHour }}</p>
        </b-modal>

        <b-modal id="addRespModal" size="lg" title="Configurar Responsáveis" hide-footer>
            <b-tabs pills vertical no-nav-style content-class="customTabsProcessContainer" class="customTabsProcess"
                v-if="this.processResps.length > 0">
                <b-tab v-for="(proc, procIdx) in processResps" :key="'process-' + procIdx" :title="proc.processName"
                    :active="procIdx == 0">
                    <CustomInputRta type="select" id="mainResp" :editable="true" :modelRef="proc.mainRespId"
                        label="Responsável" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                            proc.mainRespId = Number(event.target.value)
                        }" />
                    <CustomInputRta type="select" id="efficResp" :editable="true" :modelRef="proc.efficRespId"
                        label="Resp. Eficácia" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                            proc.efficRespId = Number(event.target.value)
                        }" />
                    <section class="auxAdd">
                        <CustomInputRta type="select" id="axuResp" :editable="true" :modelRef="auxSelectedResp"
                            label="Resp. Auxiliares" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                                auxSelectedResp = Number(event.target.value)
                            }" />
                        <button @click="addAuxResp(procIdx)">
                            <b-icon-plus />
                        </button>
                    </section>
                    <section class="auxRespSect">
                        <div v-for="(aux, auxIdx) in proc.auxResponsibles" :key="'auxResp-' + auxIdx">
                            <span>{{ aux.UserName }}</span>
                            <button @click="deleteAuxResp(procIdx, aux)">
                                <b-icon-trash-fill />
                            </button>
                        </div>
                    </section>
                </b-tab>
            </b-tabs>
            <RtaModalButtons :okFunc="saveRespsConfigs" :cancelFunc="() => this.$bvModal.hide('addRespModal')" />
        </b-modal>

        <b-modal id="addMainIndModal" title="Selecione os Indicadores Gerenciais" hide-footer size="lg" modal-class="responsive-filter-modal">
            <b-overlay :show="loadingContext" rounded="sm">
                <input type="text" v-model="searchModalInd" class="searchIndsModal" placeholder="Digite para buscar...">
                <section class="listInd">
                    <b-form-checkbox-group v-model="selectedMainInd" :options="filterModalIndicators()"
                        value-field="indicatorId" text-field="indicatorName" stacked
                        class="customCheckList"></b-form-checkbox-group>
                </section>
                <RtaModalButtons :okFunc="addMainInd" :cancelFunc="() => this.$bvModal.hide('addMainIndModal')" />
            </b-overlay>
        </b-modal>

        <b-modal id="addOperationalIndModal" title="Selecione os Indicadores Vinculados" hide-footer hide-header-close size="md">
            <b-overlay :show="loadingContext" rounded="sm">
                <input type="text" v-model="searchModalInd" class="searchIndsModal" placeholder="Digite para buscar...">
                <section class="listInd">
                    <b-form-checkbox-group v-model="selectedOpInd" :options="filterModalIndicators()"
                        value-field="indicatorId" text-field="indicatorName" stacked
                        class="customCheckList"></b-form-checkbox-group>
                </section>
                <RtaModalButtons :okFunc="addOperationalInd"
                    :cancelFunc="() => this.$bvModal.hide('addOperationalIndModal')" />
            </b-overlay>
        </b-modal>

        <b-modal id="generalConfigsModal" title="Configurações Gerais" hide-footer>
            <b-form-group label="Metodologia de Análise:" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="analysisConfSelected" :aria-describedby="ariaDescribedby" name="reason-radios"
                    :value="0">Flexível</b-form-radio>
                <b-form-radio v-model="analysisConfSelected" :aria-describedby="ariaDescribedby" name="reason-radios"
                    :value="1">Os 5 Porquês</b-form-radio>
                <b-form-radio v-model="analysisConfSelected" :aria-describedby="ariaDescribedby" name="reason-radios"
                    :value="2">6M's de Ishikawa</b-form-radio>
            </b-form-group>
            <b-form-group label="Avaliação do Plano de Ação:" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="actionAccConfSelected" :aria-describedby="ariaDescribedby" name="action-radios"
                    :value="0">Por Ação</b-form-radio>
                <b-form-radio v-if="temporaryOff" v-model="actionAccConfSelected" :aria-describedby="ariaDescribedby" name="action-radios"
                    :value="1">Avaliação Geral</b-form-radio>
                <b-form-radio v-model="actionAccConfSelected" :aria-describedby="ariaDescribedby" name="action-radios"
                    :value="2">Desabilitada</b-form-radio>
            </b-form-group>
            <b-form-group label="Desabilitar Avaliação da RTA:">
                <b-form-checkbox v-model="generalAccConfSelected" name="efficRTA-button">Desabilitar</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Desabilitar Abertura Automática da RTA:">
                <b-form-checkbox v-model="autoOpenConfSelected" name="efficRTA-button">Desabilitar</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Desabilitar Obrigatoriedade de Anexo na Avaliação de Eficácia:">
                <b-form-checkbox v-model="disableAttachmentReqConfSelected" name="disableAttachment-button">Desabilitar</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Prazo Padrão de uma RTA (dias):">
                <b-form-input v-model.number="defaultDeadlineDaysConf" type="number" min="1" step="1"
                    :state="defaultDeadlineDaysConf >= 1 && (!useMaxDeadlineConf || defaultDeadlineDaysConf <= maxDeadlineDaysConf)" />
                <b-form-invalid-feedback>Deve ser >= 1 e não maior que o limite máximo.</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Habilitar Limite Máximo de Duração da RTA:">
                <b-form-checkbox v-model="useMaxDeadlineConf">Habilitar</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Limite Máximo de Duração (dias):" v-if="useMaxDeadlineConf">
                <b-form-input v-model.number="maxDeadlineDaysConf" type="number" min="1" step="1"
                    :state="!useMaxDeadlineConf || (maxDeadlineDaysConf >= 1)" />
                <b-form-invalid-feedback>Deve ser >= 1.</b-form-invalid-feedback>
            </b-form-group>
            <RtaModalButtons :okFunc="saveConfig" :cancelFunc="() => this.$bvModal.hide('generalConfigsModal')" />
        </b-modal>

        <b-modal id="cofirmDeleteIndicator" title="Remover Indicadores" hide-footer>
            <p>Tem certeza que deseja remover o indicador selecionado?</p>
            <RtaModalButtons :okFunc="removeIndicator"
                :cancelFunc="() => this.$bvModal.hide('cofirmDeleteIndicator')" />
        </b-modal>

        <b-modal id="openTriggersConfigsModal" title="Configurar Gatilhos" size="xl" hide-footer>
            <TriggersRTA :indicator="indicatorSelectedForTrigger" :indicatorsRelated="indicatorsRelatedForTrigger"/>
        </b-modal>

        <!-- CA-01.2/01.3: alerta proativo - o Indicador Gerencial selecionado ja possui gatilhos de FCA -->
        <b-modal id="rtaFcaInfoModal" title="Indicador com FCA cadastrada" size="md" hide-footer :no-close-on-backdrop="true">
            <p>O indicador <strong>{{ fcaInfoIndicatorName }}</strong> já possui gatilho(s) de FCA cadastrado(s).</p>
            <p>Deseja ativar a verificação de supressão para <strong>não disparar um novo gatilho enquanto houver uma RTA aberta dentro do prazo</strong>?</p>
            <RtaModalButtons :okFunc="confirmEnableRtaSuppression"
                :cancelFunc="() => this.$bvModal.hide('rtaFcaInfoModal')" />
        </b-modal>
    </section>
</template>

<script>
import ManagementIndicators from './commons/ManagementIndicators.vue';
import CustomInputRta from './commons/CustomInputRta.vue';
import TriggersRTA from './commons/TriggersRTA.vue';
import RtaModalButtons from './commons/RtaModalButtons.vue';
import axios from '../../../node_modules/axios/index';
import { urlMainAPI, defaultSuccess, showError } from '../../global';
export default {
    name: "ConfigureIndicatorRta",
    components: { ManagementIndicators, CustomInputRta, TriggersRTA, RtaModalButtons },
    data() {
        return {
            temporaryOff: false,
            loading: false,
            loadingContext: false,
            searchModalInd: "",
            filterListText: "",
            selectedMainInd: [],
            selectedOpInd: [],
            processResps: [],
            auxSelectedResp: null,
            mainIdToVinc: null,
            indToDelete: {},
            indicatorsDatabaseList: [],
            indicators: [],
            usersResps: [],
            opIndDetails: {},
            analysisConfSelected: null,
            actionAccConfSelected: null,
            generalAccConfSelected: null,
            autoOpenConfSelected: null,
            disableAttachmentReqConfSelected: null,
            defaultDeadlineDaysConf: 7,
            maxDeadlineDaysConf: null,
            useMaxDeadlineConf: false,
            indicatorSelectedForTrigger: null,
            indicatorsRelatedForTrigger:[],
            fcaInfoIndicatorName: "",
            fcaContext: null
        }
    },
    watch: {
        // CA-01.2: ao selecionar um Indicador Gerencial que ja possui gatilhos de FCA,
        // dispara o alerta proativo. Verifica apenas os indicadores recem-marcados.
        selectedMainInd(newVal, oldVal) {
            const previous = Array.isArray(oldVal) ? oldVal : [];
            const added = (newVal || []).filter(id => !previous.includes(id));
            added.forEach(id => this.checkSelectedMainIndicatorFca(id));
        }
    },
    methods: {
        filterIndicators() {
            return this.filterListText != '' && this.filterListText != undefined ?
                this.indicators.filter(item => item.MainIndicatorName.toLowerCase().includes(this.filterListText.toLowerCase()) ||
                    item.OperationalInds.filter(op => op.IndicatorName.toLowerCase().includes(this.filterListText.toLowerCase())).length > 0) : this.indicators;
        },

        filterModalIndicators() {
            return this.searchModalInd != '' && this.searchModalInd != undefined ?
                this.indicatorsDatabaseList.filter(item => item.indicatorName.toLowerCase().includes(this.searchModalInd.toLowerCase())) : this.indicatorsDatabaseList;
        },

        openIndDetails(details) {
            if (!details) return;
            this.opIndDetails = { ...details };
            this.$bvModal.show("opIndDetailsRtaModal")
        },

        // CA-01.2/01.3: consulta se o indicador gerencial ja possui gatilhos de FCA e, em caso afirmativo,
        // abre o modal informando e perguntando se deseja ativar a verificacao de supressao.
        // Reusa o contexto de supressao (mesma fonte da tela de Gatilhos de Ocorrencias).
        async checkSelectedMainIndicatorFca(indicatorId) {
            try {
                const user = JSON.parse(localStorage.userKey);
                const system = user.role === "PGDI" ? "P" : "G";
                const res = await axios.get(`${urlMainAPI}/gettriggersuppressioncontext/${indicatorId}/${user.UnitId}/${system}`);
                if (res.status === 200 && res.data && res.data.hasFcaTrigger) {
                    const ind = this.indicatorsDatabaseList.find(i => i.indicatorId == indicatorId);
                    this.fcaInfoIndicatorName = ind ? ind.indicatorName : "";
                    // preserva o suppressIfOpenFca atual para nao sobrescrever ao salvar so o RTA
                    this.fcaContext = {
                        indicatorId,
                        unitId: user.UnitId,
                        system,
                        suppressIfOpenFca: res.data.suppressIfOpenFca
                    };
                    this.$bvModal.show('rtaFcaInfoModal');
                }
            } catch (e) {
                console.warn('[RTA-FCA] falha ao verificar FCA do indicador:', e && e.message);
            }
        },

        // CA-01.4: ao confirmar, persiste a regra de supressao (RTA) do indicador, marcando o checkbox
        // "nao disparar novo gatilho caso exista RTA aberta" na tela de Gatilhos de Ocorrencias.
        // Preserva o suppressIfOpenFca atual pra nao sobrescrever a outra regra.
        async confirmEnableRtaSuppression() {
            if (!this.fcaContext) { this.$bvModal.hide('rtaFcaInfoModal'); return; }
            try {
                await axios.post(`${urlMainAPI}/savesuppressionrule`, {
                    indicatorId: this.fcaContext.indicatorId,
                    unitId: this.fcaContext.unitId,
                    system: this.fcaContext.system,
                    suppressIfOpenFca: this.fcaContext.suppressIfOpenFca,
                    suppressIfOpenRta: true
                });
                defaultSuccess("Verificação de supressão de RTA ativada para o indicador.");
            } catch (e) {
                showError("Falha ao ativar a verificação de supressão.");
            } finally {
                this.$bvModal.hide('rtaFcaInfoModal');
            }
        },

        async openConfigsModal(modalname, vincId = null) {
            if (modalname == "") return;
            this.selectedMainInd = [];
            this.selectedOpInd = [];
            this.searchModalInd = "";
            this.mainIdToVinc = vincId;
            this.$bvModal.show(modalname);

            if ((modalname == "addMainIndModal" || modalname == "addOperationalIndModal") && this.indicatorsDatabaseList.length == 0) {
                this.loadingContext = true;
                await this.loadIndicatorsList();
                this.loadingContext = false;
            } else if (modalname == "addRespModal") {
                this.loadingContext = true;
                await this.loadUsers();
                await this.loadProcess();
                this.loadingContext = false;
            }
        },

        async addMainInd() {
            if (this.selectedMainInd.length == 0) {
                this.$bvToast.toast("Selecione os indicadores antes de prosseguir.", {
                    title: "Nenhum indicador selecionado",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                })
                return;
            }


            let indToSend = this.selectedMainInd.map(item => {
                return {
                    id: -9999,
                    indicatorId: item,
                    isMain: true,
                    relatedId: null
                }
            })

            this.$bvModal.hide('addMainIndModal');
            this.loading = true;

            await axios.post(`${urlMainAPI}/saveRTAIndicatorsRelated`, indToSend)
                .then(() => defaultSuccess("Indicadores Armazenados com Sucesso!"))
                .catch(() => showError("Falha ao Armazenar Indicadores."))

            await this.loadIndicatorsRelated();

            this.loading = false;
        },

        async addOperationalInd() {
            if (this.selectedOpInd.length == 0 || this.mainIdToVinc == null) {
                this.$bvToast.toast("Selecione os indicadores antes de prosseguir.", {
                    title: "Nenhum indicador selecionado",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                })
                return;
            }


            let indToSend = this.selectedOpInd.map(item => {
                return {
                    id: -9999,
                    indicatorId: item,
                    isMain: false,
                    relatedId: this.mainIdToVinc
                }
            })

            this.$bvModal.hide('addOperationalIndModal');
            this.loading = true;

            await axios.post(`${urlMainAPI}/saveRTAIndicatorsRelated`, indToSend)
                .then(() => defaultSuccess("Indicadores Armazenados com Sucesso!"))
                .catch(() => showError("Falha ao Armazenar Indicadores."))

            await this.loadIndicatorsRelated();

            this.loading = false;

        },

        addAuxResp(procIdx) {
            let userFound = this.usersResps.filter(item => item.id == this.auxSelectedResp);

            if (userFound.length > 0) {
                let exist = this.processResps[procIdx].auxResponsibles.filter(item => item.UserId == userFound[0].id);

                if (exist.length > 0) {
                    this.$bvToast.toast('Não é possível adicionar auxiliares duplicados.', {
                        title: "Usuário já adicionado.",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    })
                    return;
                }

                this.processResps[procIdx].auxResponsibles.push(
                    { UserName: userFound[0].name, UserId: userFound[0].id }
                )
            }
        },

        configTriggers(ind, related) {
            this.indicatorSelectedForTrigger = { ...ind };
            this.indicatorsRelatedForTrigger = [...related];


            this.openConfigsModal('openTriggersConfigsModal');
        },

        stopLoading() {
            this.loading = false;
            this.loadingContext = false;
        },

        askToRemoveInd(obj) {
            this.indToDelete = obj;
            this.$bvModal.show('cofirmDeleteIndicator');
        },

        async removeIndicator() {
            let toDelete = {
                id: -9999,
                indicatorId: null,
                isMain: false,
                relatedId: null
            };

            if (this.indToDelete.MainIndicatorId != undefined) {
                toDelete.indicatorId = this.indToDelete.MainIndicatorId;
                toDelete.isMain = true;
            } else {
                toDelete.indicatorId = this.indToDelete.IndicatorId;
                toDelete.relatedId = this.indToDelete.RelatedId;
            }

            this.$bvModal.hide('cofirmDeleteIndicator');
            this.loading = true;

            await axios.post(`${urlMainAPI}/deleteRTAIndicatorsRelated`, toDelete)
                .then(() =>
                    defaultSuccess("Indicadores Removidos.")
                ).catch(() => showError("Falha ao Remover Indicadores."))

            await this.loadIndicatorsRelated();
            this.loading = false;
        },

        async saveConfig() {
            if (!Number.isInteger(this.defaultDeadlineDaysConf) || this.defaultDeadlineDaysConf < 1) {
                showError("O prazo padrão deve ser um número inteiro maior que 0.");
                return;
            }
            if (this.useMaxDeadlineConf) {
                if (!Number.isInteger(this.maxDeadlineDaysConf) || this.maxDeadlineDaysConf < 1) {
                    showError("O limite máximo deve ser um número inteiro maior que 0.");
                    return;
                }
                if (this.defaultDeadlineDaysConf > this.maxDeadlineDaysConf) {
                    showError("O prazo padrão não pode ser maior que o limite máximo.");
                    return;
                }
            }

            let objToSend = {
                actionPlanRating: this.actionAccConfSelected,
                analysesMetd: this.analysisConfSelected,
                rtaAutomaticOpen: this.autoOpenConfSelected == null ? false : this.autoOpenConfSelected,
                rtaRatingOff: this.generalAccConfSelected == null ? false : this.generalAccConfSelected,
                disableAttachmentRequirement: this.disableAttachmentReqConfSelected == null ? false : this.disableAttachmentReqConfSelected,
                defaultDeadlineDays: this.defaultDeadlineDaysConf,
                maxDeadlineDays: this.useMaxDeadlineConf ? this.maxDeadlineDaysConf : null,
                useMaxDeadline: this.useMaxDeadlineConf,
            }

            this.loadingContext = true;

            await axios.post(`${urlMainAPI}/saveGeneralConfigGerencialIndicators`, objToSend)
                .then(() => defaultSuccess("Configurações Armazenadas com Sucesso!"))
                .catch(() => showError("Falha ao Armazenar Configurações."))

            this.$bvModal.hide('generalConfigsModal');

            this.loadingContext = false;
        },

        async saveRespsConfigs() {
            let procToSend = this.processResps.map(item => {
                return {
                    id: -9999,
                    principalResponsibleId: item.mainRespId,
                    efficiencyResponsibleId: item.efficRespId,
                    processId: item.processId,
                    auxResponsibles: JSON.stringify(item.auxResponsibles)
                }
            })
            this.loadingContext = true;

            await axios.post(`${urlMainAPI}/saveResponsibleProcess`, procToSend)
                .then(() => defaultSuccess("Responsáveis Configurados com Sucesso!"))
                .catch(() => showError("Falha ao Configurar Responsáveis."))

            this.$bvModal.hide('addRespModal');

            this.loadingContext = false;
        },

        deleteAuxResp(procIdx, aux){
            this.processResps[procIdx].auxResponsibles = this.processResps[procIdx].auxResponsibles.filter(i => i.UserId != aux.UserId)
        },

        async loadIndicatorsRelated() {
            await axios.get(`${urlMainAPI}/getRTAIndicatorsRelated`)
                .then(res => {
                    console.log("related: ", res.data)
                    this.indicators = res.data;
                    defaultSuccess("Indicadores Carregados com Sucesso!")
                }).catch(err => {
                    this.stopLoading();
                    console.error(err)
                    showError("Falha ao Carregar Indicadores.")
                });

                this.loading = false;
        },

        async loadProcess() {
            await axios.get(`${urlMainAPI}/getrtaprocessresponsible`).then(res => {

                this.processResps = res.data;
                defaultSuccess("Responsáveis Carregados com Sucesso!")

            }).catch(err => {
                this.stopLoading();
                console.error(err)
                showError("Falha ao Carregar Responsáveis.")

            });
        },

        async loadUsers() {
            await axios.get(`${urlMainAPI}/getusers`)
                .then(res => {
                    this.usersResps = res.data;

                }).catch(err => {
                    this.stopLoading();
                    console.error(err)
                    showError("Falha ao Carregar Usuários.")

                })
        },

        async loadRtaConfig() {
            await axios.get(`${urlMainAPI}/getGeneralConfigGerencialIndicators`)
                .then(res => {
                    if (res.data) {
                        this.analysisConfSelected = res.data.analysesMetd;
                        this.actionAccConfSelected = res.data.actionPlanRating;
                        this.generalAccConfSelected = res.data.rtaRatingOff == true ? true : null;
                        this.autoOpenConfSelected = res.data.rtaAutomaticOpen == true ? true : null;
                        this.disableAttachmentReqConfSelected = res.data.disableAttachmentRequirement == true ? true : null;
                        this.defaultDeadlineDaysConf = res.data.defaultDeadlineDays ?? 7;
                        this.maxDeadlineDaysConf = res.data.maxDeadlineDays ?? null;
                        this.useMaxDeadlineConf = res.data.useMaxDeadline == true;
                    }

                    defaultSuccess("Configurações Carregadas com Sucesso!")

                })
                .catch(err => {
                    this.stopLoading();
                    console.error(err)
                    showError("Falha ao Carregar Configurações.")

                })
        },

        async loadIndicatorsList() {
            await axios.get(`${urlMainAPI}/getNonRootIndicatorsList`)
                .then(res => {
                    this.indicatorsDatabaseList = res.data;
                    console.log('ind: ', res.data)
                    defaultSuccess("Indicadores Carregados com Sucesso!")

                })
                .catch(err => {
                    this.stopLoading();
                    console.error(err)
                    showError("Falha ao Carregar Indicadores.")

                })
        },
    },
    async mounted() {
        this.loading = true;
        this.loadRtaConfig();
        await this.loadIndicatorsRelated();
        this.loading = false;
    },
}
</script>

<style>
.customTabsProcessContainer {
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #c9c9c9;
}

.customTabsProcessContainer label {
    margin: 0.8rem 0;
}

.customTabsProcess li {
    padding: 0;
    margin: 0.2rem 0.1rem;
    width: 100%;
    max-width: 100%;
    text-align: left;
}

.customTabsProcess li a {
    border: 1px solid #949494;
    border-radius: 0.3rem;
    background-color: #ffffff;
    color: #909090;
}

.customTabsProcess li a[aria-selected="true"] {
    border-color: #00A39F;
    color: #fff;
    background-color: #00A39F;
}

.customCheckList div {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    border-bottom: 1px solid rgb(216, 216, 216);
    word-wrap: break-word;
    white-space: normal;
}

/* Responsive filter modal styling */
.responsive-filter-modal .modal-dialog {
    max-width: 90vw;
    width: auto;
    min-width: 600px;
}

.responsive-filter-modal .modal-body {
    max-height: 75vh;
    display: flex;
    flex-direction: column;
}

@media (max-width: 768px) {
    .responsive-filter-modal .modal-dialog {
        min-width: 95vw;
        max-width: 95vw;
    }
}
</style>

<style scoped>
.configHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0.2rem;
}

.configHeader div {
    display: flex;
    align-items: center;
    column-gap: 0.8rem;
    width: 100%;
}

.configHeader div:last-child {
    justify-content: flex-end;
}

.configHeader div button {
    width: max-content;
    padding: 0.3rem 0.5rem;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    font-weight: 600;
    box-sizing: 1px;
    border-style: solid;
}

.configHeader div .addIndBtn {
    background-color: #ff5f00;
    border-color: #ff5f00;
    color: #fff;
}

.configHeader div .addIndBtn:hover,
.vincIndBtn:hover,
.configTriggerBtn:hover {
    filter: grayscale(0.2);
}


.configHeader div .respBtn {
    background-color: #fff;
    border-color: #008787;
    color: #008787;
}

.configHeader div .generalConfigBtn {
    background-color: #fff;
    border-color: #ff5f00;
    color: #ff5f00;
}

.configHeader div .respBtn:hover,
.configHeader div .generalConfigBtn:hover {
    background-color: #f8f8f8;
}

.configHeader div input[type="text"] {
    max-width: 20rem;
}

.indBtnGroup {
    display: flex;
    column-gap: 0.3rem;
    align-items: center;
}

.indBtnGroup button{
    width: max-content;
    white-space: nowrap;
}

.vincIndBtn,
.configTriggerBtn {
    padding: 0.2rem 0.8rem;
    border: 1px solid;
    border-radius: 0.3rem;
    font-weight: 600;

    display: flex;
    column-gap: 0.3rem;
    align-items: center;
}

.vincIndBtn {
    background-color: #008787;
}

.configTriggerBtn {
    background-color: #FF7122;
}

.deleteIndBtn {
    color: #fff;
    background-color: #FA394D;
    border: none;
    padding: 0.2rem 0.8rem;
}

.searchIndsModal {
    width: 100%;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    padding: 0.5rem;
    font-size: 1rem;
}

.searchIndsModal::placeholder {
    color: #999;
    font-style: italic;
}

.searchIndsModal:focus {
    outline: none;
    border-color: #ff7122;
    box-shadow: 0 0 0 0.2rem rgba(255, 95, 0, 0.15);
}

.listInd {
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    column-gap: 0.3rem;
    max-height: min(70vh, 35rem);
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
}

.auxAdd {
    display: flex;
    align-items: center;
    column-gap: 0.8rem;
}

.auxAdd button,
.auxRespSect button {
    background-color: #ff5f00;
    color: #fff;
    border: 1px solid #ff5f00;
    font-size: 1.2rem;
    text-align: center;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    font-weight: 600;
}

.auxRespSect {
    height: 18rem;
    max-height: 20rem;
    overflow-y: auto;
    padding: 0.3rem 0.5rem;
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
    border: 1px solid #b6b6b6;
    border-radius: 0.2rem;
}

.auxRespSect div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dadada;
    padding: 0.3rem;
}

.auxRespSect button {
    background-color: #FA394D;
    border: 1px solid #FA394D;
    padding: 0.3rem;
}

.notFOundInd {
    color: gray;
    text-align: center;
    margin-top: 1rem;
}

.listIndContainer {
    max-height: 30rem !important;
    overflow-y: auto;
}

@media (min-width: 1700px) {
    .listIndContainer {
        max-height: 43rem !important;
    }
}
</style>